exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bi-common-draggable{position:absolute;display:inline-block;cursor:move;padding:15px}.bi-common-draggable__innerContainer{display:inline-block;cursor:default}", ""]);

// exports
